import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createCheckExistingAccountThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(ApplyProcessActionTypes.CheckExistingAccount, async (borrowerId: string) => {
    const response = await api.checkExistingAccount(borrowerId);
    return response;
  });
